angular.module('signalview.chartTemplates').run([
    'chartTemplates',
    'Chart',
    function (chartTemplates, Chart) {
        chartTemplates.register('default', function (filters) {
            const chart = Chart.create();

            // Collect metrics and other filters
            let metrics = [];
            const otherFilters = {};

            if (filters) {
                Object.keys(filters).forEach(function (key) {
                    if (key === 'sf_metric') {
                        // Handle both single metric and array of metrics
                        if (angular.isArray(filters[key])) {
                            metrics = filters[key];
                        } else {
                            metrics = [filters[key]];
                        }
                    } else {
                        otherFilters[key] = filters[key];
                    }
                });
            }

            // If no metrics specified, create one empty plot
            if (metrics.length === 0) {
                metrics = [''];
            }

            // Create a plot for each metric
            metrics.forEach(function (metric) {
                const plot = chart.plot().metric(metric);

                // Apply other filters to each plot
                Object.keys(otherFilters).forEach(function (key) {
                    plot.propertyFilter(key, otherFilters[key]);
                });
            });

            // Set chart name based on metrics
            if (metrics.length === 1 && metrics[0]) {
                chart.name(metrics[0]);
            } else if (metrics.length > 1) {
                chart.name(metrics.join(', '));
            }

            return chart;
        });
    },
]);
